// extracted by mini-css-extract-plugin
export default {"modernButtonContainer":"ExpandModernButton_modernButtonContainer__tAQwE"};